var exports = {
  "kL": "x8b4e8595--2cb56a--container",
  "oh": "x8b4e8595--2cb56a--promo-block",
  "kX": "x8b4e8595--2cb56a--promo-block--redesigned",
  "iE": "x8b4e8595--2cb56a--promo-block-image",
  "Qs": "x8b4e8595--2cb56a--content",
  "ed": "x8b4e8595--2cb56a--disclaimer",
};

module.exports = exports;
